import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Cookies } from 'react-cookie';
import SlAppIcon from '../SlAppIcon';
import SlAppStars from '../SlAppStars';
import devicePropTypes from '../../propTypes/device';
import config from '../../config';

class DeepLinkModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attemptedDeepLink: false,
      openInApp: false,
    };
    this.timeDeepLink = null;
  }

  componentDidMount() {
    const { doTrackEvent } = this.props;
    const cookies = new Cookies();
    const openInAppCookie = cookies.get('sl_open_in_app');
    if (!openInAppCookie) {
      cookies.set('sl_open_in_app', true, { maxAge: 3600 });
      this.setState({ openInApp: true });
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      doTrackEvent('Served Popup', {
        pageName: '',
        platform: 'web',
        is_mobile_view: true,
        popupName: 'Spot Page App Push',
        bodyText: "Surfline's better in the App",
      });
    }
  }

  componentWillUnmount() {
    if (this.timeDeepLink) clearTimeout(this.timeDeepLink);
    document.body.style.position = 'relative';
    document.body.style.width = 'auto';
  }

  attemptDeepLink = () => {
    const { spotId, spotName, segment } = this.props;
    const encodedName = encodeURIComponent(spotName);
    window.location = `surfline://spot?id=${spotId}&name=${encodedName}&segment=${segment}}`;
    this.timeDeepLink = setTimeout(() => {
      this.setState({ attemptedDeepLink: true });
    }, 20);
  };

  closeModal = () => {
    this.setState({ openInApp: false });
    document.body.style.position = 'relative';
    document.body.style.width = 'auto';
  };

  handleButtonClick = () => {
    const { attemptedDeepLink } = this.state;
    const { doTrackEvent, device } = this.props;
    doTrackEvent('Clicked Popup', {
      pageName: 'Spot Report',
      platform: 'web',
      is_mobile_view: device.width < config.tabletLargeWidth,
      popupName: 'Spot Page App Push',
      bodyText: "Surfline's better in the App",
      buttonText: attemptedDeepLink ? 'Download App' : 'Open App',
    });
    if (attemptedDeepLink) {
      window.location = config.appStoreUrl;
    } else {
      this.attemptDeepLink();
    }
  };

  render() {
    const { attemptedDeepLink, openInApp } = this.state;
    if (!openInApp) return null;
    return (
      <div className="sl-deep-link-modal__container">
        <div className="sl-deep-link-modal">
          <div className="sl-deep-link-modal__content">
            <div className="sl-deep-link-modal__description">
              <SlAppIcon />
              <div className="sl-deep-link-modal__message">
                <h5>Surfline&apos;s better in the App</h5>
                <div className="sl-deep-link-modal__description__rating">
                  <SlAppStars />
                  <span>6.05k Ratings</span>
                </div>
              </div>
            </div>
            <div className="sl-deep-link-modal__buttons">
              <button
                className="sl-deep-link-modal__button--decline"
                onClick={this.closeModal}
                onTouchEnd={this.closeModal}
                type="button"
              >
                No Thanks
              </button>
              <button
                onClick={this.handleButtonClick}
                onTouchEnd={this.handleButtonClick}
                type="button"
              >
                {`${attemptedDeepLink ? 'Download ' : 'Open '} App`}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DeepLinkModal.propTypes = {
  segment: PropTypes.string.isRequired,
  spotId: PropTypes.string.isRequired,
  spotName: PropTypes.string.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  device: devicePropTypes.isRequired,
};

export default DeepLinkModal;
